import { useEffect, useState, useRef } from 'react';

/**
 * Detecta si hi ha una versió nova del frontend desplegada.
 * Consulta /version.json cada X mil·lisegons i compara amb la versió
 * que hi havia quan es va carregar l'app per primer cop.
 * Posat cada 30 minuts
 */
export default function useVersionCheck(intervalMs = 1800000) {
  const [newVersionAvailable, setNewVersionAvailable] = useState(false);
  const initialVersionRef = useRef(null);

  useEffect(() => {
    let cancelled = false;

    const check = async () => {
      try {
        const res = await fetch(`/version.json?t=${Date.now()}`, {
          cache: 'no-store',
        });
        if (!res.ok) return;

        const data = await res.json();
        if (cancelled) return;

        if (initialVersionRef.current === null) {
          initialVersionRef.current = data.version;
        } else if (data.version !== initialVersionRef.current) {
          setNewVersionAvailable(true);
        }
      } catch (e) {
        // Silenciem errors de xarxa
      }
    };

    check();
    const intervalId = setInterval(check, intervalMs);

    return () => {
      cancelled = true;
      clearInterval(intervalId);
    };
  }, [intervalMs]);

  return newVersionAvailable;
}